import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EmbedReplitComponent } from './embed-replit.component';

//

@NgModule({
  declarations: [EmbedReplitComponent],
  imports: [
    CommonModule, // Import CommonModule to enable *ngIf, *ngFor, etc.
  ],
  exports: [
    EmbedReplitComponent, // Export if needed elsewhere, good practice
  ],
})
export class EmbedReplitModule {}
